import { render, staticRenderFns } from "./FireRiskSettings.layout.vue?vue&type=template&id=98993cd6&scoped=true"
import script from "./FireRiskSettings.layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./FireRiskSettings.layout.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FireRiskSettings.layout.vue?vue&type=style&index=0&id=98993cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98993cd6",
  null
  
)

export default component.exports